import $ from "jquery";

function Toggle() {
  //ボタン押下でアコーディオン開閉
  $(".js-toggle-trigger").on("click", function (e) {
    e.preventDefault();
    const toggle = $(this).closest(".js-toggle");
    const panel = toggle.find(".js-toggle-panel");

    if (toggle.hasClass("is-open")) {
      toggle.removeClass("is-open");
      panel.slideUp();
      // aria属性
      $(this).attr("aria-expanded", false);
    } else {
      toggle.addClass("is-open");
      panel.slideDown();
      // aria属性
      $(this).attr("aria-expanded", true);
    }
  });
}

export { Toggle };
